"use strict";

require("core-js/modules/es7.array.includes");

require("core-js/modules/es6.string.includes");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es7.object.values");

require("core-js/modules/es6.array.filter");

require("core-js/modules/es6.array.find");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var index_1 = require("../index");

function findPaletteByColor(searchColor) {
  var result = Object.values(index_1.colors).filter(function (color) {
    return typeof color !== "string";
  }).find(function (color) {
    return Object.values(color).includes(searchColor);
  });

  if (!result) {
    throw new Error("Could not find color in palette");
  }

  return result;
}

exports.findPaletteByColor = findPaletteByColor;